// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__er8kA","label":"styles_label__3x6CO"};